module.exports = __webpack_public_path__ + "img/logo_docue_black.34f77f3.svg";